var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHamburgerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "2em",
  height: "2em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.25 6.75A.75.75 0 0 1 6 6h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m0 5.25a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m0 5.25A.75.75 0 0 1 6 16.5h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75",
  clipRule: "evenodd"
})));
export default SvgHamburgerIcon;